import httpClient from 'shared/lib/httpClient';
import { parseDiseaseList } from '../schemas/MasterDataSchema';

/**
 * Fetch disease master-data list (ICD-10) from the super-admin scope.
 * Same payload as `getDiseaseList`, but served under /super-admin — the
 * plain /diseases route is forbidden (403) for super-admin sessions.
 *
 * @param {Object} params - query params (search, page, limit, sort, ...)
 * @param {AbortSignal} [signal] - cancellation signal from React Query
 * @returns {Promise<{ data: DiseaseItem[], meta: { http_status, last_page, ... } }>}
 */
export const getSuperAdminDiseaseList = async (params, signal) => {
  const response = await httpClient.get('/super-admin/diseases', {
    params,
    signal,
  });
  return parseDiseaseList(response?.data);
};
